import { ButtonBase } from '@mui/material';
import { styled } from '@mui/material/styles';

type SelectableOptionItemStyledProps = {
  selected: boolean;
};

export const SelectableOptionItemStyled = styled(ButtonBase, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<SelectableOptionItemStyledProps>(({ theme, selected }) => ({
  display: 'block',
  width: '100%',
  textAlign: 'left',
  borderRadius: Number(theme.shape.borderRadius) * 2,
  border: '1px solid',
  borderColor: selected ? theme.palette.primary.main : theme.palette.divider,
  boxShadow: selected ? `0 0 0 1px ${theme.palette.primary.main}` : 'none',
  cursor: 'pointer',
  transition: theme.transitions.create(['border-color', 'box-shadow']),
  '&:hover': {
    borderColor: theme.palette.primary.main,
  },
}));
